<!--
/**
* @name: List.vue
* @description: 文章管理-内容管理列表页面
* @author: 杨波
* @create: 2020/08/31 14:06:58
* @update: 2020/08/31 14:06:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入内容名称" clearable v-model="para.name"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择内容分类" block clearable v-model="para.categoryCode">
          <k-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" block clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAdd">新建</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="contentList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="contentList && contentList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import {
  NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_PAGELIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_STATUS_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
} from "@/assets/modules/apiList";
const initPara = () => ({
  name: "",
  categoryCode: "",
  type: "2",
  status: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      para: initPara(),
      isLoading: false,
      typeList: [],
      channelList: [],
      statusList: [
        { value: "1", label: "启用" },
        { value: "2", label: "停用" },
      ],
      contentList: [],
      total: 0,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "销售渠道",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.channelList.length; i++) {
              if (row.channelCode == this.channelList[i].code) {
                temp = this.channelList[i].name;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "内容名称",
          field: "name",
          style: {
            width: 200,
            textAlign: "center",
          },
        },
        {
          name: "分类",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.typeList.length; i++) {
              if (row.categoryCode == this.typeList[i].value) {
                temp = this.typeList[i].name;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "浏览量",
          field: "viewNum",
          style: {
            width: 120,
            textAlign: "center",
          },
        },
        {
          name: "点赞量",
          field: "giveLikeNum",
          style: {
            width: 120,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.status}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "操作人",
          field: "updateBy",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender:row=>(
            <insensitive val={row.updateBy} isShowEye={false}></insensitive>
          )
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
            width: 150,
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            return <div>{editButton}</div>;
          },
        },
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getContentList();
    },
    onReset() {
      this.para = initPara();
    },
    onEdit(row) {
      const { id } = row;
      this.$controller.open({
        name: "contentAdd",
        query: {
          refresh: new Date() - 0,
          id,
          edit: 1,
        },
        title: "编辑内容",
      });
    },
    onAdd() {
      this.$controller.open({
        name: "contentAdd",
        query: {
          refresh: new Date() - 0,
        },
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getContentList();
    },
    onChangeStatus(row) {
      let { id, status } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.status == "1" ? "停用" : "启用"}该素材？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_STATUS_UPDATE,
            para: { id, status: row.status == "1" ? 2 : 1 },
          })
            .then(() => {
              this.isLoading = false;
              this.getContentList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getContentList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_PAGELIST,
        para,
      }).then((res) => {
        this.contentList = res.pageList;
        this.total = res.total;
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getTypeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: { parentCode: "contentType" },
      }).then((res) => {
        this.typeList = res;
      });
    },
  },
  created() {
    this.getContentList();
    this.getTypeList();
    this.getChannelList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getContentList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
